module.exports = __webpack_public_path__ + "img/phase2-gallery-05.4351e9cb.png";